import {
  Button,
  Checkbox,
  FormControlLabel,
  Menu,
  MenuItem,
  TableBody,
  TableContainer,
  TableHead,
} from "@material-ui/core";
import React from "react";
import BaseLayout from "../../components/BaseLayout/BaseLayout";
import { useMutation, useQuery } from "react-query";
import DeliveryService from "../../Services/DeliveryService";
import PropertyService from "../../Services/PropertyService";
import { handleError } from "../../components/Utils/Utils";
import { Skeleton } from "@material-ui/lab";
import FormDialog from "./parts/form";
import { formatCurrency } from "../../components/Utils/Currency";
import { capitalize } from "../../Helpers/string";
import {
  StyledTable,
  StyledTableCell,
  StyledTableRow,
} from "../../components/CustomStyles/CustomTable";
import { IzySwitch } from "../../components/CustomStyles/CustomSwitch";
import { notifUtils } from "../../components/NotifUtils/NotifUtils";
import MoreVertIcon from "@material-ui/icons/MoreVert";
import { confirm } from "../../components/ConfirmationDialog/ConfirmationDialog";

const user = JSON.parse(localStorage.getItem("user"));

const DropdownMenu = (props) => {
  const { data, action, onClickEdit, onClickDelete } = props;
  const [anchorEl, setAnchorEl] = React.useState("");

  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const handleClickEdit = () => {
    handleClose();
    onClickEdit(data);
  };

  const handleClickDelete = () => {
    handleClose();
    onClickDelete(data);
  };

  return (
    <React.Fragment>
      <Button
        aria-controls="simple-menu"
        aria-haspopup="true"
        onClick={handleClick}
      >
        <MoreVertIcon />
      </Button>
      <Menu
        anchorEl={anchorEl}
        keepMounted
        open={Boolean(anchorEl)}
        onClose={handleClose}
      >
        {action.update && <MenuItem onClick={handleClickEdit}>Edit</MenuItem>}
        {action.delete && (
          <MenuItem onClick={handleClickDelete}>Delete</MenuItem>
        )}
      </Menu>
    </React.Fragment>
  );
};

const PropertyDelivery = (props) => {
  const action = props.params;
  const propertyID = user?.operational?.id || 0;
  const [activeDelivery, setActiveDelivery] = React.useState(false);
  const [propertyData, setPropertyData] = React.useState("");
  const [propertyVendorData, setPropertyVendorData] = React.useState("");
  const [formData, setFormData] = React.useState("");
  const [deliveryPackages, setDeliveryPackages] = React.useState([]);

  // Form State
  const [openDialog, setOpenDialog] = React.useState(false);
  const [formType, setFormType] = React.useState("add");

  const mutationCreatePropertyVendor = useMutation(
    DeliveryService.postDeliveryVendor,
    {
      onSuccess: (data, variables) => {
        setPropertyVendorData(data);
        setActiveDelivery(true);
      },
      onError: (error, variables) => {
        handleError(error);
      },
    }
  );

  const mutationPathPropertyVendor = useMutation(
    DeliveryService.patchDeliveryVendor,
    {
      onSuccess: (data, variables) => {
        setPropertyVendorData(data?.data);
        setActiveDelivery(data?.data?.active_st);
      },
      onError: (error, variables) => {
        handleError(error);
      },
    }
  );

  const getDeliveryPackages = useQuery(
    ["getPropertyDeliveryPackages", propertyVendorData?.id || 0],
    () => {
      return DeliveryService.getDeliveryPackages({
        vendor_id: propertyVendorData?.id || 0,
      }).then((res) => res?.data);
    },
    {
      enabled: false,
      retry: false,
      onSuccess: (data) => {
        setDeliveryPackages(data);
      },
    }
  );

  const mutationPathDeliveryPackage = useMutation(
    DeliveryService.patchDeliveryPackage,
    {
      onSuccess: (data, variables) => {
        notifUtils("Success Update Active Status", "success");
        getDeliveryPackages.refetch();
      },
      onError: (error, variables) => {
        handleError(error);
      },
    }
  );

  const mutationDeleteDeliveryPackage = useMutation(
    DeliveryService.deleteDeliveryPackage,
    {
      onSuccess: (data, variables) => {
        notifUtils("Success Delete Delivery Package", "success");
        getDeliveryPackages.refetch();
      },
      onError: (error, variables) => {
        handleError(error);
      },
    }
  );

  const getPropertyDetail = useQuery(
    ["getPropertyDetail", propertyID],
    () => {
      return PropertyService.getDetail(propertyID).then((res) => res.data);
    },
    {
      enabled: false,
      retry: false,
      onSuccess: (data) => {
        setPropertyData(data);
      },
      onError: (err) => {
        handleError(err);
      },
    }
  );

  const getPropertyDeliveryVendor = useQuery(
    ["getPropertyDeliveryVendor", propertyID],
    () => {
      return DeliveryService.getPropertyDeliveryVendor(propertyID).then(
        (res) => res.data
      );
    },
    {
      enabled: false,
      retry: false,
      onSuccess: (data) => {
        setPropertyVendorData(data[0]);
        setActiveDelivery(data[0]?.active_st);
      },
      onError: (err) => {
        const res = err?.response;
        if (res?.status === 404) {
          const params = {
            name: propertyData?.name,
            image: propertyData?.logo?.square || "",
            description: "",
            initial: propertyData?.initial,
            token_auth: "",
            token_callback: "",
            url: "",
            active_st: activeDelivery,
            client_id: "",
            client_secret: "",
            property: {
              id: propertyData?.id,
            },
          };
          mutationCreatePropertyVendor.mutate(params);
        }
      },
    }
  );

  const handleChange = (e) => {
    const active_st = e.target.checked;

    const params = [
      {
        op: "replace",
        path: "/active_st",
        value: active_st,
      },
    ];

    mutationPathPropertyVendor.mutate({ id: propertyVendorData?.id, params });
  };

  const handleChangeActiveSt = (e, data) => {
    const active_st = e.target.checked;

    const params = [
      {
        op: "replace",
        path: "/active_st",
        value: active_st,
      },
    ];

    mutationPathDeliveryPackage.mutate({ id: data?.id, params });
  };

  const handleClickEdit = (data) => {
    setFormType("edit");
    setFormData(data);
    setOpenDialog(!openDialog);
  };

  const handleClickDelete = (data) => {
    confirm(
      "Remove Delivery Package",
      "Are you sure to remove this item ?"
    ).then(async (onProcess) => {
      mutationDeleteDeliveryPackage.mutate(data?.id);
    });
  };

  const handleCloseForm = () => {
    setOpenDialog(false);
    setFormData("");
    setFormType("add");
  };

  const handleToggleForm = () => {
    setOpenDialog(!openDialog);
  };

  React.useEffect(() => {
    getPropertyDetail.refetch();
  }, []);

  React.useEffect(() => {
    if (propertyData !== "") {
      getPropertyDeliveryVendor.refetch();
    }
  }, [propertyData]);

  React.useEffect(() => {
    if (propertyVendorData !== "") {
      getDeliveryPackages.refetch();
    }
  }, [propertyVendorData]);

  return (
    <BaseLayout background="gray">
      <div className="row mx-0">
        <div className="col-12 px-0">
          <h3 className="font-16 font-bold mb-0">
            Property / Property Delivery
          </h3>
        </div>
        <div className="col-12 mt-3 px-0">
          <div className="card border-0 rounded-8px">
            <div className="card-body">
              {!getPropertyDeliveryVendor?.isLoading &&
                !getPropertyDetail?.isLoading &&
                getPropertyDeliveryVendor?.isSuccess &&
                getPropertyDetail?.isSuccess && (
                  <React.Fragment>
                    <div className="form-group font-14 mb-3">
                      <FormControlLabel
                        control={
                          <Checkbox
                            checked={activeDelivery}
                            onChange={(e) => handleChange(e)}
                            name="active_delivery"
                            color="primary"
                            style={{
                              StyledTableRowansform: "scale(0.8)",
                            }}
                          />
                        }
                        label={
                          <span className="font-14">
                            Activated Property Delivery
                          </span>
                        }
                      />
                    </div>
                    {propertyVendorData?.active_st &&
                      deliveryPackages?.length > 0 && (
                        <TableContainer>
                          <StyledTable>
                            <TableHead>
                              <StyledTableRow>
                                <StyledTableCell width="5%">No</StyledTableCell>
                                <StyledTableCell width="20%">
                                  Package Name
                                </StyledTableCell>
                                <StyledTableCell width="10%">
                                  Base Fee
                                </StyledTableCell>
                                <StyledTableCell width="10%">
                                  Type
                                </StyledTableCell>
                                <StyledTableCell width="15%">
                                  Max Distance (Km)
                                </StyledTableCell>
                                <StyledTableCell width="10%">
                                  Max Weight (gr)
                                </StyledTableCell>
                                <StyledTableCell width="15%">
                                  Max Dimension (Cm)
                                </StyledTableCell>
                                <StyledTableCell width="5%">
                                  Active
                                </StyledTableCell>
                                <StyledTableCell width="10%"></StyledTableCell>
                              </StyledTableRow>
                            </TableHead>
                            <TableBody className="font-10">
                              {deliveryPackages?.map((value, index) => (
                                <StyledTableRow key={value?.id}>
                                  <StyledTableCell>{index + 1}</StyledTableCell>
                                  <StyledTableCell>
                                    {value?.name} ({value?.package_code || "-"})
                                  </StyledTableCell>
                                  <StyledTableCell>
                                    {formatCurrency(
                                      value?.vendor?.property?.currency,
                                      value?.base_fee?.toString()
                                    )}
                                  </StyledTableCell>
                                  <StyledTableCell>
                                    {capitalize(value?.cons_type)}
                                  </StyledTableCell>
                                  <StyledTableCell>
                                    {value?.max_distance_value > 0
                                      ? formatCurrency(
                                          value?.vendor?.property?.currency,
                                          value?.max_distance_value?.toString(),
                                          true
                                        )
                                      : "-"}
                                    {value?.max_distance_free > 0
                                      ? " (Free delivery within radius " +
                                        formatCurrency(
                                          value?.vendor?.property?.currency,
                                          value?.max_distance_free?.toString(),
                                          true
                                        ) +
                                        " Km)"
                                      : ""}
                                  </StyledTableCell>
                                  <StyledTableCell>
                                    {value?.max_weight_value > 0
                                      ? formatCurrency(
                                          value?.vendor?.property?.currency,
                                          value?.max_weight_value?.toString(),
                                          true
                                        )
                                      : "-"}
                                  </StyledTableCell>
                                  <StyledTableCell>
                                    {formatCurrency(
                                      value?.vendor?.property?.currency,
                                      value?.max_dimension_length?.toString(),
                                      true
                                    ) +
                                      " (L) x " +
                                      formatCurrency(
                                        value?.vendor?.property?.currency,
                                        value?.max_dimension_width?.toString(),
                                        true
                                      ) +
                                      " (W) x " +
                                      formatCurrency(
                                        value?.vendor?.property?.currency,
                                        value?.max_dimension_height?.toString(),
                                        true
                                      ) +
                                      " (H)"}
                                  </StyledTableCell>
                                  <StyledTableCell>
                                    <IzySwitch
                                      size="small"
                                      checked={value?.active_st}
                                      color="primary"
                                      name="out_of_stock"
                                      onChange={(e) => {
                                        handleChangeActiveSt(e, value);
                                      }}
                                      disabled={!action.patch || !action.update}
                                    />
                                  </StyledTableCell>
                                  <StyledTableCell>
                                    {(action.update || action.delete) && (
                                      <DropdownMenu
                                        data={value}
                                        action={action}
                                        onClickEdit={handleClickEdit}
                                        onClickDelete={handleClickDelete}
                                      />
                                    )}
                                  </StyledTableCell>
                                </StyledTableRow>
                              ))}
                            </TableBody>
                          </StyledTable>
                        </TableContainer>
                      )}
                    {propertyVendorData?.active_st && (
                      <div className="form-group mt-4">
                        <button
                          type="button"
                          className="btn btn-blue btn-block btn-md border-0"
                          onClick={() => handleToggleForm()}
                        >
                          Add Delivery Package
                        </button>
                      </div>
                    )}
                  </React.Fragment>
                )}
              {getPropertyDeliveryVendor?.isLoading ||
                (getPropertyDetail?.isLoading && (
                  <React.Fragment>
                    <div className="form-group font-16 mb-3">
                      <Skeleton />
                    </div>
                    <p className="font-12">
                      <Skeleton />
                    </p>
                    <p className="font-12">
                      <Skeleton />
                    </p>
                    <p className="font-12">
                      <Skeleton />
                    </p>
                  </React.Fragment>
                ))}
            </div>
          </div>
        </div>
      </div>
      <FormDialog
        isShow={openDialog}
        type={formType}
        onClose={handleCloseForm}
        vendorData={propertyVendorData}
        formData={formData}
        refetch={() => getDeliveryPackages.refetch()}
      />
    </BaseLayout>
  );
};

export default PropertyDelivery;
